export default defineNuxtRouteMiddleware(async () => {
    const {isLoggedIn} = useAuthStore();
    if (isLoggedIn) return navigateTo({name: 'index'}, { replace: true });
});